import moment from "moment";
import { Languages } from "config/translations/I18n";
import { Gender } from "common/enums/GenderEnum";
import { Address } from "common/models/Address";

export interface PatientType {
  readonly id: number;
  readonly firstName: string;
  readonly lastName: string;
  readonly gender?: Gender;
  readonly birthDate?: Date;
  readonly inss?: string;
  readonly address?: Address;
  readonly language: Languages | undefined;
}

export class Patient implements PatientType {
  id: number;
  firstName: string;
  lastName: string;
  gender?: Gender;
  birthDate?: Date;
  inss?: string;
  address?: Address;
  language: Languages | undefined;

  constructor(data?: PatientType) {
    this.id = -1;
    this.firstName = "";
    this.lastName = "";
    this.address = new Address();
    data && Object.assign(this, data);
    data &&
      data.address &&
      Object.assign(this.address, new Address(data.address));
  }

  getNameAsReadableString(): string {
    return [this.lastName, this.firstName].join(" ");
  }

  getAge(): number {
    if (this.birthDate) {
      return moment().diff(this.birthDate, "years", false);
    } else {
      return 0;
    }
  }

  getInitials(): string {
    return [this.lastName.substr(0, 1), this.firstName.substr(0, 1)]
      .join("")
      .toUpperCase();
  }

  getAddressAsReadableString(): string {
    if (this.address) {
      const addressLine = [this.address.street, this.address.number]
        .filter(Boolean)
        .join(" ");
      const cityLine = [this.address.zip, this.address.municipality]
        .filter(Boolean)
        .join(" ");
      return [addressLine, cityLine].filter(Boolean).join(", ");
    } else {
      return "";
    }
  }
}
